export default class Root
    @Copy: (source={}, target) ->
        for property, value of source
            continue if value == null
            # if property not of target
            #     console.warn "#{target.constructor.name}: `#{property}` is an unknown property"
            target[property] = value
        return